<template>
  <div class="px-2 sm:px-0 w-full">
    <div class="flex w-full flex-col sm:flex-row sm:justify-between mb-3 sm:mb-5">
      <p class="self-start hidden sm:flex sm:self-center text-xl font-bold text-purple_dark">
        {{centers.length}} Isolation Center(s)
      </p>
      <div class="self-end">
        <button
                @click="addCenter()"
                class="sm:w-full flex bg-transparent bg-purple_dark sideBackground text-white font-semibold hover:text-white py-2 px-4 hover: rounded-lg">

          Add New Center
        </button>
      </div>
    </div>
    <div class="flex flex-wrap w-full">
      <div :key="center.key" class="w-full sm:w-1/2 lg:w-1/3  mb-3 sm:mb-6" v-for="center in centers">
        <div class="rounded-lg shadow-lg bg-white sm:mr-4">
          <div class="w-full  p-3">
            <p class="text-2xl capitalize text-purple_dark font-medium">
              {{center.area}}
            </p>
            <p>
              Latitude : {{center.lat}}
            </p>
            <p>
              Longitude : {{center.lng}}
            </p>
          </div>
          <div class="flex">
            <button
                    @click="editCenter(center)"
                    class="w-1/2 bg-blue text-white flex justify-center font-semibold hover:text-white py-2 px-4 hover: rounded-bl-lg">
              <Edit3Icon></Edit3Icon>
            </button>
            <button
                    @click="deleteCenter(center)"
                    class="w-1/2 bg-red-medium  flex justify-center text-white font-semibold hover:bg-red-dark py-2 px-4 hover: rounded-br-lg">
              <Trash2Icon></Trash2Icon>
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import {eventBus} from "../../eventbus";
  import {db} from "../../db";
  import { Trash2Icon,Edit3Icon } from 'vue-feather-icons'

  export default {
    name: "IsolationContent",
    components:{
      Trash2Icon,Edit3Icon
    },
    props: {
      centers: {
        type: Array
      },
      isolationKeys: {
        type: Array
      }
    },
    methods: {
      addCenter() {
        eventBus.$emit('AddCenter')
      },
      editCenter(x) {
        eventBus.$emit('EditCenter', x)
      },
      // eslint-disable-next-line no-unused-vars
      deleteCenter(x) {
        this.$confirm(`Are you sure you want to delete ${x.area}?`, '',
            "error")
            .then(() => {
              let center = this.isolationKeys.find(item => item.area === x.area);
              db.ref('isolation_centre/' + `${center.key}`).remove().then(() => {
                this.$toast.open({
                  message: 'Successful',
                  type: 'success'
                });
              })
            })
            .catch(() => {
            });

      }
    }

  }
</script>

<style scoped>

</style>